import { colors } from '../theme';
import * as React from 'react';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Box, IconButton, Tooltip } from '@mui/material';
import { SITE_CONFIG, buildWhatsAppUrl } from '../config/site';

const Social = () => {
  const iconSx = {
    color: colors.text,
    border: '1px solid var(--dxd-border)',
    backgroundColor: colors.surface,
    '&:hover': {
      color: colors.accent,
      borderColor: colors.accent,
      backgroundColor: colors.tint,
    },
  };

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Tooltip title="Instagram" arrow>
        <IconButton
          component="a"
          href={SITE_CONFIG.instagramUrl}
          aria-label="Abrir Instagram de DiscoXDiscos"
          target="_blank"
          rel="noreferrer"
          sx={iconSx}
        >
          <InstagramIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="YouTube" arrow>
        <IconButton
          component="a"
          href={SITE_CONFIG.academyYoutubeUrl}
          aria-label="Abrir YouTube de X Academia de DJ"
          target="_blank"
          rel="noreferrer"
          sx={iconSx}
        >
          <YouTubeIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="WhatsApp" arrow>
        <IconButton
          component="a"
          href={buildWhatsAppUrl()}
          aria-label="Contactar por WhatsApp"
          target="_blank"
          rel="noreferrer"
          sx={iconSx}
        >
          <WhatsAppIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default Social;
